import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { withStyles } from '@material-ui/core/styles';
import sanitizeRestProps from './sanitizeRestProps';

const styles = {
  imageRadius: {
    maxWidth: 'initial',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
  },
  imageWidth: {
    maxWidth: '100px',
  },
};

const ImageLinkField = withStyles(styles)(
  ({
    className,
    classes = {},
    record,
    source,
    src,
    title,
    imgixParams = 'w=100',
    ...rest
  }) => {
    const sourceValue = get(record, source);
    if (!sourceValue) {
      return <div className={className} {...sanitizeRestProps(rest)} />;
    }

    if (Array.isArray(sourceValue)) {
      return (
        <ul {...sanitizeRestProps(rest)}>
          {sourceValue.map((file) => {
            const titleValue = file[title] || title;
            const srcValue = file[src] || title;

            return (
              <li key={file}>
                <img
                  alt={titleValue}
                  title={titleValue}
                  src={srcValue}
                  className={classes.image}
                />
              </li>
            );
          })}
        </ul>
      );
    }

    const titleValue = record[title] || title;

    return (
      <div className={className} {...sanitizeRestProps(rest)}>
        <a href={sourceValue} target="_blank" rel="noopener noreferrer">
          <img
            title={titleValue}
            alt={titleValue}
            src={`${sourceValue}?${imgixParams}`}
            className={`${classes.imageWidth} ${
              source === 'avatar_image_url' ? `${classes.imageRadius}` : ''
            }`}
          />
        </a>
      </div>
    );
  },
);

ImageLinkField.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  src: PropTypes.string,
  title: PropTypes.string,
};

ImageLinkField.defaultProps = {
  classes: {},
  className: '',
  record: {},
  title: '',
  src: '',
};

export default ImageLinkField;
